// extracted by mini-css-extract-plugin
module.exports = {"pagePrevNextButton":"Pagination_pagePrevNextButton__2bqUt"};